export default __webpack_public_path__ + "static/media/checkbox.7d61a131.svg";